var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { StyledButton } from 'components/Shared/StyledButton/StyledButton';
import { getUserOrSignIn } from 'services/auth/AuthService';
import { createLock, checkUserLockPreventsEdit } from 'utils/cpa-utils';
import { BannerIconType, BannerMessageType, useBanner } from 'components/Shared/BannerContext/BannerContext';
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { CpaBodyContainer } from '../CpaBodyContainer/CpaBodyContainer';
import { NotesTable } from './NotesTable/NotesTable';
export function CpaNotes() {
    var _this = this;
    var cpaProductContext = useCpaProduct();
    var _a = useBanner(), setBannerMessage = _a.setBannerMessage, setBannerType = _a.setBannerType, setBannerIcon = _a.setBannerIcon, setShowBanner = _a.setShowBanner, setIsRefreshEnabled = _a.setIsRefreshEnabled;
    var _b = useState(false), showAddRow = _b[0], setShowAddRow = _b[1];
    var closeAddRow = function () {
        setShowAddRow(function (curValue) { return !curValue; });
    };
    var handleClick = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var cpn, sessionId, user, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cpn = cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.cpn;
                    sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                    if (!(cpn && sessionId)) return [3 /*break*/, 5];
                    return [4 /*yield*/, getUserOrSignIn()];
                case 1:
                    user = _a.sent();
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, createLock(cpn, user.name, sessionId, cpaProductContext.data.currentProduct.startDate)];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    err_1 = _a.sent();
                    setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                    setBannerType(BannerMessageType.Warning);
                    setBannerIcon(BannerIconType.Error);
                    setShowBanner(true);
                    setIsRefreshEnabled(true);
                    return [3 /*break*/, 5];
                case 5:
                    if (!checkUserLockPreventsEdit(cpn)) {
                        setShowAddRow(value);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(CpaBodyContainer, __assign({ title: "Notes", buttons: {
            rightButtons: [
                _jsx(StyledButton, { disabled: cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled, labelText: "Add Note", backgroundColorVariation: "primary", width: "100px", buttonAction: function () { return handleClick(true); } }),
                _jsx(StyledButton, { labelText: "Select Notes", backgroundColorVariation: "secondary", width: "100px", disabled: cpaProductContext === null || cpaProductContext === void 0 ? void 0 : cpaProductContext.data.isEditDisabled, buttonAction: function () { return null; } }),
            ],
        } }, { children: _jsx(NotesTable, { showAddRow: showAddRow, showAddRowAction: closeAddRow }) })));
}
